/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DesktopNotificationDto { 
    id?: string;
    message?: string | null;
    link?: string | null;
    userId?: number;
    tenantId?: number;
    read?: boolean;
    creationTime?: string;
}

